const lbaMultiSelectGroup = angular.module('app.lbaMultiSelectGroup', []);

lbaMultiSelectGroup.controller('lbaMultiSelectGroupCtrl', require('./lbaMultiSelectGroupCtrl'));
lbaMultiSelectGroup.directive('lbaMultiSelectGroup', require('./lbaMultiSelectGroupDir'));

export default lbaMultiSelectGroup;



// WEBPACK FOOTER //
// ./src/components/lbaMultiSelectGroup/index.js